import axios from "axios";

function getProducts(id) {
    const response = axios
      .get(
        `https://recom-power.cn/wp-json/recom-wordpress/v1/load-product-attributes-table/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      )
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        const errorMessage = err.message;
        throw new Error(errorMessage);
      });
    return response;
}

export { getProducts };
